import { useQuery } from "@tanstack/react-query";
import { validatePdfLink } from "helpers/api";
import { useState } from "react";

// To determine if a paper's open_access_pdf_url can be used with Chat with Paper, we need to
// determine if the link goes directly to a pdf file, or to e.g. a sign-in-gated publisher site.
// To do so, make a HEAD request to the url and look to see if it is a PDF file type.

const useIsPdfLink = (url?: string) => {
  const [error, setError] = useState<string | null>(null);

  const {
    data,
    error: queryError,
    isLoading,
  } = useQuery(["validate-pdf-link", url], () => validatePdfLink(url ?? ""), {
    enabled: !!url,
    retry: false,
    onError: (err: any) => {
      setError(`Request failed: ${err.message}`);
    },
  });

  const isPdfLink = data?.isPdf ?? null;

  return {
    isPdfLink,
    error: queryError ? queryError.message : error,
    isLoading,
  };
};

export default useIsPdfLink;
